import React from "react";
import warningImg from "../Assets/imgs/landing/Warning.png";

interface FailurePopUpProps {
  message: string;
  onClose: () => void;
}

const FailurePopUp = ({ message, onClose }: FailurePopUpProps) => {
  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <img src={warningImg} alt="warning" style={styles.image} />
        <h2 style={styles.title}>Subscription Failed</h2>
        <p style={styles.subtitle}>{message}</p>
        <button style={styles.button} onClick={onClose}>
          Ok
        </button>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  card: {
    background: "linear-gradient(145deg, #1a1a3e, #0d0d1f)",
    border: "1px solid rgba(231, 76, 60, 0.4)",
    borderRadius: "24px",
    padding: "40px 32px 32px",
    maxWidth: "340px",
    width: "90%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    boxShadow: "0 0 40px rgba(231, 76, 60, 0.2), 0 8px 32px rgba(0,0,0,0.5)",
  },
  image: {
    width: "90px",
    height: "90px",
    objectFit: "contain",
    marginBottom: "20px",
    filter: "drop-shadow(0 0 12px rgba(231, 76, 60, 0.5))",
  },
  title: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#ffffff",
    margin: "0 0 12px",
    letterSpacing: "0.3px",
  },
  subtitle: {
    fontSize: "14px",
    color: "rgba(255,255,255,0.65)",
    lineHeight: 1.7,
    margin: "0 0 28px",
  },
  button: {
    width: "100%",
    padding: "14px",
    background: "linear-gradient(90deg, #c0392b, #e74c3c)",
    color: "#fff",
    fontSize: "16px",
    fontWeight: 600,
    border: "none",
    borderRadius: "14px",
    cursor: "pointer",
    boxShadow: "0 4px 20px rgba(231, 76, 60, 0.4)",
  },
};

export default FailurePopUp;
